export default "__VITE_ASSET__COVK5U2n__"